// extracted by mini-css-extract-plugin
export default {"device-card":"dovpE","device-card--small":"WqXgZ","device-card--medium":"nbNG4","device-card--large":"BQlU5"};